import React from 'react';
import { ReportWidgetLoader } from '../ReportWidgetLoader';
import { getTrendDateLabel } from '@src/utils/datesUtils';
import TrendCard from '@src/components/features/reports-and-logs/executive-summary/widgets/TrendCard/TrendCard';
import { BaseWidgetProps } from '@src/components/features/reports-and-logs/executive-summary/widgets/types';
import { TryAgainWidgetMessage } from '@src/components/shared/try-again-message/try-again-widget-message';

const AllowedSessionsTrendCard: React.FC<BaseWidgetProps> = (props) => (
  <ReportWidgetLoader hookProps={{ ...props, reportName: 'allowedSessions' }}>
    {(data, error) => (
      error ? <TryAgainWidgetMessage /> :
        <TrendCard
        total={data.total}
        title="Allowed sessions"
        trendPercent={data.trendPercent}
        trendLabel={getTrendDateLabel(props.fromDate, props.toDate)}
        trendColor="#2D7E24"
        data={data.data}
      />
    )}
  </ReportWidgetLoader>
);

export default AllowedSessionsTrendCard;
